module.exports = __webpack_public_path__ + "media/banners/cuk-bg-f6cd4f5e.jpg";